import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edf79532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mapper-table panel" }
const _hoisted_2 = { class: "level" }
const _hoisted_3 = { class: "level-left" }
const _hoisted_4 = { class: "level-item" }
const _hoisted_5 = { class: "has-text-weight-normal" }
const _hoisted_6 = { class: "level-right" }
const _hoisted_7 = { class: "level-item" }
const _hoisted_8 = { class: "button is-text is-small" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There are problems in the table:", -1))
const _hoisted_10 = { class: "panel-block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Identifier template:", -1))
const _hoisted_12 = { class: "identifier-template" }
const _hoisted_13 = ["data-column-mapping-id", "onMouseenter", "onMouseleave"]
const _hoisted_14 = { class: "is-flex gap-2" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "has-text-grey"
}
const _hoisted_17 = {
  key: 1,
  class: "has-text-grey"
}
const _hoisted_18 = { class: "is-flex" }
const _hoisted_19 = { class: "panel-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_dropdown_item = _resolveComponent("o-dropdown-item")!
  const _component_o_dropdown = _resolveComponent("o-dropdown")!
  const _component_b_message = _resolveComponent("b-message")!
  const _component_property_display = _resolveComponent("property-display")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "panel-heading",
      style: _normalizeStyle({ 'background-color': _ctx.table.color })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.prefix) + " ", 1),
            _createTextVNode(_toDisplayString(_ctx.table.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_hydra_operation_button, {
              operation: _ctx.table.actions.edit,
              to: { name: 'TableEdit', params: { tableId: _ctx.table.clientPath } }
            }, null, 8, ["operation", "to"]),
            _createVNode(_component_hydra_operation_button, {
              operation: _ctx.table.actions.delete,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteTable(_ctx.table))),
              "data-testid": "delete-table"
            }, null, 8, ["operation"]),
            _createVNode(_component_o_dropdown, {
              position: "bottom-left",
              class: "has-text-weight-normal"
            }, {
              trigger: _withCtx(() => [
                _createElementVNode("button", _hoisted_8, [
                  _createVNode(_component_o_icon, { icon: "ellipsis-h" })
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.table.csvw)
                  ? (_openBlock(), _createBlock(_component_o_dropdown_item, {
                      key: 0,
                      tag: "div",
                      "item-class": "p",
                      "has-link": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: { name: 'TableCsvw', params: { tableId: _ctx.table.clientPath } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View generated CSVW ")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 4),
    (_ctx.errors.length)
      ? (_openBlock(), _createBlock(_component_b_message, {
          key: 0,
          type: "is-danger",
          class: "content"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
              return (_openBlock(), _createElementBlock("pre", {
                key: error.id.value
              }, _toDisplayString(error.description), 1))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("code", _hoisted_12, _toDisplayString(_ctx.table.identifierTemplate || 'auto'), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.columnMappings, (columnMapping) => {
      return (_openBlock(), _createElementBlock("div", {
        key: columnMapping.id.value,
        class: "panel-block is-justify-content-space-between",
        "data-column-mapping-id": columnMapping.id.value,
        onMouseenter: ($event: any) => (_ctx.$emit('highlight-arrows', [columnMapping.id.value])),
        onMouseleave: ($event: any) => (_ctx.$emit('unhighlight-arrows', [columnMapping.id.value]))
      }, [
        _createElementVNode("div", _hoisted_14, [
          (columnMapping.referencedTable)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "tag is-rounded",
                style: _normalizeStyle({ 'background-color': _ctx.getTableColor(columnMapping.referencedTable.id) })
              }, [
                _createVNode(_component_property_display, {
                  term: columnMapping.targetProperty
                }, null, 8, ["term"])
              ], 4))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createVNode(_component_property_display, {
                  term: columnMapping.targetProperty
                }, null, 8, ["term"]),
                (columnMapping.datatype)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createTextVNode(" ("),
                      _createVNode(_component_property_display, {
                        term: columnMapping.datatype
                      }, null, 8, ["term"]),
                      _createTextVNode(")")
                    ]))
                  : _createCommentVNode("", true),
                (columnMapping.language)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (language: " + _toDisplayString(columnMapping.language.value) + ")", 1))
                  : _createCommentVNode("", true)
              ])),
          (columnMapping.isKeyDimension)
            ? (_openBlock(), _createBlock(_component_o_tooltip, {
                key: 2,
                label: "Key dimension"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_icon, {
                    icon: "key",
                    variant: "grey"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (columnMapping.isMeasureDimension)
            ? (_openBlock(), _createBlock(_component_o_tooltip, {
                key: 3,
                label: "Measure dimension"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_icon, {
                    icon: "chart-bar",
                    variant: "primary"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_hydra_operation_button, {
            operation: columnMapping.actions.edit,
            to: { name: 'ColumnMappingEdit', params: { columnMappingId: columnMapping.clientPath } }
          }, null, 8, ["operation", "to"]),
          _createVNode(_component_hydra_operation_button, {
            operation: columnMapping.actions.delete,
            onClick: ($event: any) => (_ctx.deleteColumnMapping(columnMapping))
          }, null, 8, ["operation", "onClick"])
        ])
      ], 40, _hoisted_13))
    }), 128)),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.table.actions.createLiteralColumnMapping || _ctx.table.actions.createReferenceColumnMapping)
        ? (_openBlock(), _createBlock(_component_o_tooltip, {
            key: 0,
            label: "Map column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_o_button, {
                tag: "router-link",
                to: { name: 'ColumnMappingCreate', params: { tableId: _ctx.table.clientPath } },
                variant: "text",
                size: "small",
                "icon-left": "plus",
                "data-testid": "create-column-mapping"
              }, null, 8, ["to"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}